import 'bootstrap/dist/css/bootstrap.min.css';
import { useState, useEffect, useRef } from 'react';
import Header from "./pages/Header";
import SubGrupos from "./pages/SubGrupos";
import Produtos from './pages/Produtos';
import axios from 'axios';

const styles = {
    body: {
        width: '100%',
        minHeight: '95vh',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        margin: 0,
    },
};

function App() {
    const subgrupoRefs = useRef({});
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [subGrupos, setSubGrupos] = useState([]);
    const [produtos, setProdutos] = useState([]);

    const getTabelasApi = async()=>{
        const route = `${urlApi}/pegar-tabelas`;

        const resposta = await axios.get(route);
        const data = resposta.data;

        setSubGrupos(data.subgrupos);
        setProdutos(data.produtos);
    };

    const handleSelectSubgrupo = (nomeSubgrupo) => {
        subgrupoRefs.current[nomeSubgrupo]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    useEffect(()=>{
        getTabelasApi();
    }, []);

    return (
        <div style={styles.body}>
            <Header />
            <SubGrupos subgrupos={subGrupos} onSelect={handleSelectSubgrupo}/>
            <Produtos produtos={produtos} subgrupoRefs={subgrupoRefs}/>
        </div>
    );
}

export default App;
